/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ContractDocumentsControllerFindAllQueryResponse, ContractDocumentsControllerFindAllQueryParams, ContractDocumentsControllerFindAll401, ContractDocumentsControllerFindAll403 } from "../../models/contractDocumentsController/ContractDocumentsControllerFindAll";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { contractDocumentsControllerFindAll } from "../../clients/contract-documentsService/contractDocumentsControllerFindAll";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const contractDocumentsControllerFindAllQueryKey = (params: ContractDocumentsControllerFindAllQueryParams = {}) => [{
  url: '/api/v1/contract-documents'
}, ...(params ? [params] : [])] as const;
export type ContractDocumentsControllerFindAllQueryKey = ReturnType<typeof contractDocumentsControllerFindAllQueryKey>;
export function contractDocumentsControllerFindAllQueryOptions(params?: ContractDocumentsControllerFindAllQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = contractDocumentsControllerFindAllQueryKey(params);
  return queryOptions<ContractDocumentsControllerFindAllQueryResponse, ResponseErrorConfig<ContractDocumentsControllerFindAll401 | ContractDocumentsControllerFindAll403>, ContractDocumentsControllerFindAllQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return contractDocumentsControllerFindAll(params, config);
    }
  });
}

/**
 * @summary List a project's contract documents (filter[scopeId] required)
 * {@link /api/v1/contract-documents}
 */
export function useContractDocumentsControllerFindAll<TData = ContractDocumentsControllerFindAllQueryResponse, TQueryData = ContractDocumentsControllerFindAllQueryResponse, TQueryKey extends QueryKey = ContractDocumentsControllerFindAllQueryKey>(params?: ContractDocumentsControllerFindAllQueryParams, options: {
  query?: Partial<QueryObserverOptions<ContractDocumentsControllerFindAllQueryResponse, ResponseErrorConfig<ContractDocumentsControllerFindAll401 | ContractDocumentsControllerFindAll403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? contractDocumentsControllerFindAllQueryKey(params);
  const query = useQuery({
    ...contractDocumentsControllerFindAllQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ContractDocumentsControllerFindAll401 | ContractDocumentsControllerFindAll403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}